// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionCurtain_wrapper__fMrUg","innerWrapper":"ActionCurtain_innerWrapper__Qni+C","top":"ActionCurtain_top__uVmwz","title":"ActionCurtain_title__I56HA"};